import React, { Fragment, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import { Button, Modal, ModalBody } from "reactstrap";
import imageUploader from "../../../utilities/imageUploader";
import axios from "../../../axios/axios";
import Swal from "sweetalert2";

const AddImageGallery = ({ isUpdate, setIsUpdate }) => {
  const [modal, setModal] = useState(false);
  const [cover, setCover] = useState(null);
  const [images, setImages] = useState(null);
  const [btnActive, setBtnActive] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const handleSubmit = async (e) => {
    console.log("inside fn");

    e.preventDefault();

    const form = e.target;
    const album_name = form.album_name.value;

    const cover_url = await imageUploader(cover);
    console.log("img", album_name, cover_url);

    const postData = { album_name, cover_url };

    try {
      await axios.post("/image-gallery", postData);
      Swal.fire({
        icon: "success",
        title: "Your work has been saved",
        showConfirmButton: false,
        timer: 1500,
      });
      toggle();
      setIsUpdate(!isUpdate);
    } catch (error) {
      alert("Error submitting data.");
    }
  };

  return (
    <Fragment>
      <Button color="primary" onClick={toggle}>
        Add New Image Gallery
      </Button>
      <Modal
        isOpen={modal}
        toggle={toggle}
        className="modal-body"
        centered={true}
      >
        <ModalBody>
          <div className="card">
            <div className="card-header">
              <h5>Image Gallery Uploader</h5>
            </div>
            <form
              onSubmit={(e) => {
                setBtnActive(false);
                handleSubmit(e);
              }}
              className="form theme-form"
            >
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="text-capitalize" htmlFor="album_name">
                        Name
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        id="album_name"
                        onChange={() => setBtnActive(true)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label text-capitalize">
                        Image
                      </label>
                      <div className="col-sm-9">
                        <input
                          className="form-control"
                          type="file"
                          id="fileInput"
                          onChange={(e) => {
                            setCover(e.target.files[0]);
                            setBtnActive(true);
                          }}
                          accept="image/*"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="col-sm-3 col-form-label text-capitalize">
                        Album Images
                      </label>
                      <div className="col-sm-9">
                        <input
                          className="form-control"
                          type="file"
                          id="fileInput"
                          accept="image/*"
                          onChange={(e) => {
                            setImages(e.target.files);
                            setBtnActive(true);
                          }}
                          required
                          multiple
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div>
                <Button
                  disabled={!btnActive}
                  className="me-2"
                  type="submit"
                  color="primary"
                >
                  Save
                </Button>
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AddImageGallery;
